/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import Navbar from "./Navbar";
import Header from "./Header";
import baseUrl from "./BaseUrl";
import Loader from "./Loader";
import { useNavigate , Link} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const Dashboard = () => {

    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [popupOpen, setPopupOpen] = useState(false);
    const [summary, setSummary] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [displayFromDate, setDisplayFromDate] = useState('');
    const [displayToDate, setDisplayToDate] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        refreshToken();
    }, []);

    useEffect(() => {
        setName('Pauser');
    }, []);

    useEffect(() => {
        if (token) loadSummary('', '');
    }, [token]);

    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        } catch (error) {
           console.log(error.response)
            if (error.response) {
               navigate("/");
               window.location.reload();
            }
        }
    }

    const axiosJWT = axios.create();

    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/admin/api/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwtDecode(response.data.accessToken);
            setExpire(decoded.exp);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    const loadSummary = async (from, to) => {
        setPopupOpen(true);
        try {
            const url = `${baseUrl}/admin/api/dashboard-summary${from && to ? `?from_date=${from}&to_date=${to}` : ''}`;
            const response = await axiosJWT.get(url, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (response.data && response.data.success) {
                setSummary(response.data.data);
            }
        } catch (err) {
            console.log(err);
        } finally {
            setPopupOpen(false);
        }
    };

    const handleFromDate = (date) => {
        const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        setFromDate(formatted);
        setDisplayFromDate(date);
    };
    const handleToDate = (date) => {
        const formatted = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        setToDate(formatted);
        setDisplayToDate(date);
    };
    const handleApply = () => {
        if (fromDate && toDate) loadSummary(fromDate, toDate);
    };
    const handleClear = () => {
        setFromDate(''); setToDate('');
        setDisplayFromDate(''); setDisplayToDate('');
        loadSummary('', '');
    };

    const fmtDelta = (n) => {
        if (n === null || n === undefined) return '—';
        const sign = n > 0 ? '+' : '';
        return `${sign}${n}%`;
    };
    const deltaClass = (n) => {
        if (n === null || n === undefined) return '';
        if (n > 0) return 'delta-up';
        if (n < 0) return 'delta-down';
        return '';
    };

    const allTime = summary?.all_time || {};
    const period = summary?.period;

    return (
        <div className="panelbox">
           <Navbar />
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader />
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Dashboard</h1>
                            </div>
                        </div>
                        <div className="col-6">

                        </div>
                    </div>

                    {/* All-time KPI strip */}
                    <div className="row numberboxes">
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Total Users
                                    <span className="kpi-hint">All registered users, excluding hard-deleted accounts</span>
                                </h3>
                                <p>{allTime.total_users ?? '—'}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>DAU / WAU / MAU
                                    <span className="kpi-hint">Daily / Weekly / Monthly Active Users — distinct existing users (excludes deleted) whose activity falls in today / today + prior 6 days / today + prior 29 days, UTC</span>
                                </h3>
                                <p>{allTime.dau ?? '—'} / {allTime.wau ?? '—'} / {allTime.mau ?? '—'}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Total Installs
                                    <span className="kpi-hint">App installs ever recorded, excluding TestFlight and internal builds</span>
                                </h3>
                                <p>{allTime.total_installs ?? '—'}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Active Subscriptions
                                    <span className="kpi-hint">Paid subscriptions active right now, same as Total Active Subscriptions on User Subscription (Manual users not counted)</span>
                                </h3>
                                <p>{allTime.total_subscriptions_active ?? '—'}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Android Users
                                    <span className="kpi-hint">Users whose platform = Android (excludes deleted)</span>
                                </h3>
                                <p>{allTime.android_users ?? '—'}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>iOS Users
                                    <span className="kpi-hint">Users whose platform = iOS (excludes deleted)</span>
                                </h3>
                                <p>{allTime.ios_users ?? '—'}</p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Deleted Users
                                    <span className="kpi-hint">Accounts soft- or hard-deleted (deleted_at is set)</span>
                                </h3>
                                <p>{allTime.deleted_users ?? '—'}</p>
                            </div>
                        </div>
                        {/* Opens of the Follow Pauser page (080). An em dash here means the count
                            is unavailable — V117 not applied in this environment — not zero. */}
                        <div className="col-md-3">
                            <div className="dashboard-box" id="number">
                                <h3>Follow Us Page Opens
                                    <span className="kpi-hint">Times the Follow Pauser page has been opened from its app notice. Every open counts, repeats by the same member and opens we could not attribute included</span>
                                </h3>
                                <p data-testid="kpi-follow-us-page-views">{allTime.follow_us_page_views ?? '—'}</p>
                            </div>
                        </div>
                    </div>

                    {/* Date-range picker — selecting a range reveals the high-perf period boxes */}
                    <div className="row">
                        <div className="col-md-12 order-filter transection-filter">
                            <div className="boxinput">
                                <DatePicker
                                    selected={displayFromDate}
                                    onChange={handleFromDate}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="From Date"
                                    className="from-date"
                                />
                                <DatePicker
                                    selected={displayToDate}
                                    onChange={handleToDate}
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="To Date"
                                    className="end-date"
                                />
                                <button className="search-btn" onClick={handleApply} disabled={!fromDate || !toDate}>Apply</button>
                                {(fromDate || toDate) && (
                                    <button type="button" className="search-btn clear-btn" onClick={handleClear}>Clear</button>
                                )}
                            </div>
                        </div>
                    </div>

                    {period && (
                        <div className="row numberboxes" data-testid="dashboard-period-boxes">
                            <div className="col-12">
                                <div className="left-title">
                                    <h3>Selected period: {period.from_date} → {period.to_date}
                                      <span className="period-sub"> (vs {period.prior_from_date} → {period.prior_to_date})</span>
                                    </h3>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="dashboard-box" id="number">
                                    <h3>New Users
                                        <span className="kpi-hint">Signups whose created_at falls in the selected range; delta vs the same-length window just before it</span>
                                    </h3>
                                    <p>{period.new_users} <span className={`delta ${deltaClass(period.delta_new_users_pct)}`}>{fmtDelta(period.delta_new_users_pct)}</span></p>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="dashboard-box" id="number">
                                    <h3>New Installs
                                        <span className="kpi-hint">App installs in the selected range (excludes TestFlight / internal builds); delta vs prior window</span>
                                    </h3>
                                    <p>{period.new_installs} <span className={`delta ${deltaClass(period.delta_new_installs_pct)}`}>{fmtDelta(period.delta_new_installs_pct)}</span></p>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="dashboard-box" id="number">
                                    <h3>New Subscriptions
                                        <span className="kpi-hint">Subscriptions whose startTimeMillis falls in the selected range; delta vs prior window</span>
                                    </h3>
                                    <p>{period.new_subscriptions} <span className={`delta ${deltaClass(period.delta_new_subscriptions_pct)}`}>{fmtDelta(period.delta_new_subscriptions_pct)}</span></p>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row numberboxes">
                         <div className="col-md-3">
                            <Link to="/users">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img src={`${process.env.PUBLIC_URL}/images/bx-user.png`} alt="" />
                                </div>
                                <h3>Users</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/installation-data-statics">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img className="white-color" src={`${process.env.PUBLIC_URL}/images/download.png`} alt="" />
                                </div>
                                <h3>Installations</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-heart-rate-sessions">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt="" />
                                </div>
                                <h3>Alerts</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-pause-count">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt="" />
                                </div>
                                <h3>Pauses</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-monitor-sessions">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt="" />
                                </div>
                                <h3>Monitor Sessions</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-permissions">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img src={`${process.env.PUBLIC_URL}/images/notification.png`} alt="" />
                                </div>
                                <h3>Permissions</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-subscription">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt="" />
                                </div>
                                <h3>User Subscription</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/active-users">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt="" />
                                </div>
                                <h3>Active Users</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-bio-vitals">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt="" />
                                </div>
                                <h3>Bio Vitals</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-medicine">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt="" />
                                </div>
                                <h3>Medicine</h3>
                            </div>
                            </Link>
                        </div>
                        <div className="col-md-3">
                            <Link to="/user-sleep-sessions">
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img className="white-color" src={`${process.env.PUBLIC_URL}/images/file.png`} alt="" />
                                </div>
                                <h3>Sleep Sessions</h3>
                            </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Dashboard
